module.exports = __webpack_public_path__ + "static/media/fawry-bg.90e5da77.png";